import React, { createContext, useContext, useState, useEffect } from 'react';
import {
  loginUser,
  logoutUser,
  fetchUser,
} from '../modules/auth/services/authService';
import { showSuccessToast } from '../utils/toastHelper';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

const AuthProvider = ({ children }) => {
  const [authToken, setAuthToken] = useState(null);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getUser = async () => {
      try {
        const token = localStorage.getItem('authToken');
        if (token) {
          setAuthToken(token);
          setLoading(true);
          const userData = await fetchUser();
          if (userData.user) {
            console.log('userData', userData);
            // setUser(JSON.stringify(userData.user));
            setUser(userData.user);
          }
        }
      } catch (error) {
        console.error('Error fetching user:', error);
      } finally {
        setLoading(false);
      }
    };

    getUser();
  }, []);
  if (loading) {
    return <span className="loader"></span>;
  }

  const login = async (email, password) => {
    setLoading(true);
    const data = await loginUser(email, password);
    console.log('data:', data);
    if (data.token) {
      setAuthToken(data.token);
      localStorage.setItem('authToken', data.token);
      setUser(JSON.stringify(data.user));
      setUser(data.user);
      setLoading(false);
      showSuccessToast(data.message);

      return true;
    }
    setLoading(false);
    return false;
  };

  const logout = async () => {
    const data = await logoutUser();
    setAuthToken(null);
    setUser(null);
    localStorage.removeItem('authToken');
    if (data) {
      showSuccessToast(data.message);
    }
  };

  return (
    <AuthContext.Provider
      value={{ authToken, user, login, logout, loading, setLoading, setUser }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
